import { useLocalStorage } from '@vueuse/core'
import { LocalStorageKeys, LocalStorageKeyManager } from '~/store/LocalStorageKeyManager'
import type { Redirect } from '~/store/redirect/types'

export const useReturnUrlLocalStore = () =>
  useLocalStorage<Redirect>(LocalStorageKeyManager.createStorageKey(LocalStorageKeys.REDIRECT), {
    project: null,
    returnUrl: null,
  })
